import { Button, Col, Flex, Row, Space } from "antd";
import FormItem from "antd/es/form/FormItem";
import { FormDatePicker, FormSelect } from "components/form/FormProvide";
import FormAntd from "components/form/FormProvide/FormAntd";
import { useTranslation } from "react-i18next";

const UpdateTimesheetFilter = ({
    handleSearch = () => { },
    timesheetOptions = []
}) => {
    const { t } = useTranslation();

    return (
        <FormAntd
            onFinish={handleSearch}
        >
            <FormItem shouldUpdate={(prev, curv) => {
                return false
            }}>
                {({ getFieldValue, setFieldValue, resetFields }) => {
                    return (
                        <Space direction="vertical" size={24} style={{ width: "100%" }}>
                            <Flex vertical gap={16}>
                                <Row gutter={24} style={{ marginLeft: "0px" }}>
                                    <Col span={12}>
                                        <FormSelect
                                            name="projectId"
                                            label={t("setting_project.label.projectName")}
                                            placeholder={t('report.please_select')}
                                            size="large"
                                            options={timesheetOptions}
                                        />
                                    </Col>
                                    <Col span={12}>
                                        <FormSelect
                                            name="approveStatus"
                                            label={t("my_timesheet.label.request_status")}
                                            placeholder={t('report.please_select')}
                                            size="large"
                                            options={[
                                                { value: 'Draft', label: t("approve-status.draft") },
                                                { value: 'Pending', label: t("approve-status.pending") },
                                                { value: 'Approved', label: t("approve-status.approve") },
                                            ]}
                                            allowClear
                                        />
                                    </Col>
                                </Row>

                                <Row gutter={24} style={{ marginLeft: "0px" }}>
                                    <Col span={12}>
                                        <FormDatePicker
                                            name="dateTimeRecord"
                                            label={t("my_timesheet.label.dateTimeRecord")}
                                            placeholder={t('report.please_select')}
                                            size="large"
                                        />
                                    </Col>
                                    <Col span={12}>
                                        <FormDatePicker
                                            name="month"
                                            label={t("my_timesheet.label.month")}
                                            placeholder={t('report.please_select')}
                                            size="large"
                                            picker="month"
                                            dateFormat="MMM"
                                            required
                                        />
                                    </Col>
                                </Row>
                            </Flex>
                            <Row gutter={24} style={{ justifyContent: "end", display: "flex", gap: "16px" }}>
                                <Button
                                    type="default"
                                    onClick={() => { resetFields() }}
                                    style={{ borderRadius: "8px" }} size="large"
                                >
                                    {t("common.cancel").toUpperCase()}
                                </Button>
                                <Button
                                    type="primary"
                                    htmlType="submit"
                                    style={{ borderRadius: "8px", backgroundColor: "var(--button-color)", boxShadow: "none" }}
                                    size="large"
                                >
                                    {t("common.search").toUpperCase()}
                                </Button>
                            </Row>
                        </Space>
                    )
                }}
            </FormItem>
        </FormAntd>
    )
}

export default UpdateTimesheetFilter;